import { take, put, takeLatest, race, call, delay } from 'redux-saga/effects';

import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';
import * as createAppointment from '../requests/create-apppointment-req';
import * as inspectAppointment from '../requests/appointment-inspector-req';
import { emitClearSelectionEvent } from '../../../utils/schedule/events';
import { loadScheduleSearchSlots } from './fetch-schedule-saga';
import * as success from '../../ui/success';
import * as error from '../../ui/error';

const ERROR_CODES = {
  PROVIDER_UNAVAILABLE: 'appointment_provider_unavailable',
  NOT_MATCHED_PATIENT_TYPE: 'appointment_not_matching_patient_type',
  OVERLAP: 'appointment_overlapping',
};

function getSchedulableError(fieldList) {
  if (fieldList.find(({ code }) => code === ERROR_CODES.PROVIDER_UNAVAILABLE)) {
    return 'calendar.errors.appointment.unavailableProvider';
  }

  if (
    fieldList.find(({ code }) => code === ERROR_CODES.NOT_MATCHED_PATIENT_TYPE)
  ) {
    return 'calendar.errors.appointment.patientTypeMismatch';
  }

  return 'calendar.errors.appointment.common';
}

function* inspectAppointmentCreation(payload) {
  yield put(inspectAppointment.actions.send(payload));

  const { succeed, failed } = yield race({
    succeed: take(inspectAppointment.actions.succeed),
    failed: take([
      inspectAppointment.actions.rejected,
      inspectAppointment.actions.errorEncountered,
    ]),
  });

  if (failed) {
    yield put(error.actions.update({ id: 'errors.common' }));
    return false;
  }

  const { payload: inspection } = succeed;
  const [params, schedulable] = inspection;
  if (!params.completed) {
    console.log('>__TODO: handle this error::: ', params);
    return false;
  }

  if (!schedulable.completed) {
    const { fieldList } = schedulable;
    const isOverlap = fieldList.find(
      ({ code }) => code === ERROR_CODES.OVERLAP,
    );

    if (isOverlap) {
      yield put(scheduleValidateActions.toggleOverlapAppointment(true));
      yield take(SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP);
      return true;
    }

    const errorI18n = getSchedulableError(fieldList);
    yield put(error.actions.update({ id: errorI18n }));

    return false;
  }

  return true;
}

function* handleCreateAppointmnet(action) {
  const { payload } = action;
  const canCreate = yield call(inspectAppointmentCreation, payload);

  if (canCreate) {
    yield put(createAppointment.actions.send(action.payload));
    yield take(createAppointment.actions.succeed);
    yield call(emitClearSelectionEvent);
    yield call(loadScheduleSearchSlots);
    yield delay(150);
    yield put(
      success.actions.update({ id: 'virtualVisit.details.visitScheduled' }),
    );
  }
}

export default function* createAppointmentSaga() {
  yield takeLatest([createAppointment.consts.START], handleCreateAppointmnet);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/create-appointment-saga.js